import { ChangeEvent, forwardRef, useMemo } from "react"
import { Input, InputProps, InputRef } from "antd"

interface InputPatternProps {
  pattern: RegExp
}
export const InputPattern = forwardRef<
  InputRef,
  Omit<InputProps, "pattern"> & InputPatternProps
>(({ onChange: onChangeOriginal, pattern, ...props }, ref) => {
  const onChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value

    if (pattern.test(newValue) || newValue === "") {
      onChangeOriginal && onChangeOriginal(event)
    }
  }

  return (
    <Input {...props} onChange={onChange} ref={ref} value={props.value || ""} />
  )
})
